import { Thumbnail_default } from "./chunk-ZVNNF3K4.js";
import { Thumbnail_Button_default } from "./chunk-OJSANH6C.js";

// src/elements/Thumbnail/index.ts
var ThumbnailComponent = Thumbnail_default;
ThumbnailComponent.Button = Thumbnail_Button_default;
ThumbnailComponent.Button.displayName = "Thumbnail.Button";
export { ThumbnailComponent };